export const GETTEL_DEVICE_TOKEN_KEY = 'gettel_device_token';
export const GETTEL_AUTHORIZED_DEVICE_ID_KEY = 'gettel_authorized_device_id';

export function getStoredDeviceToken(): string | null {
  if (typeof window === 'undefined') return null;
  const value = localStorage.getItem(GETTEL_DEVICE_TOKEN_KEY);
  return value && value.trim() !== '' ? value.trim() : null;
}

export function setStoredDeviceToken(token: string): void {
  localStorage.setItem(GETTEL_DEVICE_TOKEN_KEY, token.trim());
}

export function getStoredAuthorizedDeviceId(): string | null {
  if (typeof window === 'undefined') return null;
  const value = localStorage.getItem(GETTEL_AUTHORIZED_DEVICE_ID_KEY);
  return value && value.trim() !== '' ? value.trim() : null;
}

export function setStoredAuthorizedDeviceId(deviceId: string): void {
  localStorage.setItem(GETTEL_AUTHORIZED_DEVICE_ID_KEY, deviceId.trim());
}

export function clearStoredDeviceToken(): void {
  localStorage.removeItem(GETTEL_DEVICE_TOKEN_KEY);
  localStorage.removeItem(GETTEL_AUTHORIZED_DEVICE_ID_KEY);
}

/** Header name expected by GettelApi on login / refresh. */
export const DEVICE_TOKEN_HEADER = 'X-Device-Token';

export function applyDeviceTokenHeader(
  headers: Record<string, unknown> | undefined
): Record<string, unknown> {
  const next = { ...(headers ?? {}) };
  const deviceToken = getStoredDeviceToken();
  if (deviceToken) {
    next[DEVICE_TOKEN_HEADER] = deviceToken;
  }
  return next;
}
